import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchPlaceholder: {
		id: 'navigation.global-side-navigation.object-list-flyout.searchPlaceholder',
		defaultMessage: 'Search...',
		description: 'Default placeholder text for the search input',
	},
	clearSearchIconLabel: {
		id: 'navigation.global-side-navigation.object-list-flyout.clearSearchIconLabel',
		defaultMessage: 'Clear search',
		description: 'Label for clear icon in search input',
	},
	filterIconLabel: {
		id: 'navigation.global-side-navigation.object-list-flyout.filterIconLabel',
		defaultMessage: 'Filters',
		description: 'Label for filters icon in search bar',
	},
	selectedFiltersVisualLabel: {
		id: 'navigation.global-side-navigation.object-list-flyout.selectedFilters',
		defaultMessage: 'Selected: ',
		description:
			'Visual label for the selected filters. Shown before an interactive tag list component that shows a tag for each selected filter.',
	},
	selectedFiltersAccessibleLabel: {
		id: 'navigation.global-side-navigation.object-list-flyout.selectedFilters',
		defaultMessage: 'Selected filters',
		description: 'Label for the selected filters group, used for assistive technologies',
	},
	removeFilterIconLabel: {
		id: 'navigation.global-side-navigation.object-list-flyout.removeFilterIconLabel',
		defaultMessage: 'Remove',
		description: 'Label for remove icon in selected filter tag',
	},
});
